<template>
  <div></div>
</template>

<script setup>
import { router } from "@/plugins/1.router";
import { onMounted, onUnmounted } from "vue";

// ✅ Sadece production modda çalışsın
const isProduction = import.meta.env.MODE === "production";
// const isProduction = true;

onMounted(() => {
  if (isProduction) {
    // sag menu engelleme
    document.addEventListener("contextmenu", (e) => e.preventDefault());
  }
});

let interval = null;

function isDevtoolsOpen() {
  const threshold = 160;
  const widthDiff = window.outerWidth - window.innerWidth;
  const heightDiff = window.outerHeight - window.innerHeight;
  return widthDiff > threshold || heightDiff > threshold;
}

function handleDevtools() {
  if (isDevtoolsOpen()) {
    // Örneğin boş pencere açıp mevcut sayfayı kapat
    // window.open("about:blank", "_blank");
    // window.close();
    // Eğlenceli uyarı ekranı yerine özel bir modal veya yönlendirme yap
    const style = `
       position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background: #000;
    color: #0f0;
    font-family: monospace;
    font-size: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    white-space: pre-wrap;
    text-align: left;
    padding: 10px;
    `;

    const message = `

AygulYazilim Opss Sistemleri

Geliştirici Modu Tespit Edildi!

Geliştirici araçına mı girdin? 😏
Kodlar korktu ve kendini imha etti! 💥
Giriş sayfasına yönlendiriliyorsun...
`;

    const overlay = document.createElement("div");
    overlay.setAttribute("style", style);
    overlay.textContent = message;
    document.body.appendChild(overlay);

    router.push({ name: "login" });
    // alert("Lütfen geliştirici araçlarını kapatın!");
    // alert(
    //   "Oops! Geliştirici modu açıldı ve sistem şoke oldu. Giriş sayfasına sürgün edildin! 🚀"
    // );
  }
}

onMounted(() => {
  // devtools acilmasini engelleme
  if (isProduction) {
    interval = setInterval(() => {
      handleDevtools();
    }, 1000);
  }
});

onUnmounted(() => {
  if (isProduction) {
    clearInterval(interval);
  }
});
</script>
